import styled from "styled-components";

const Inline = styled.div`
  display: flex;
  align-items: center;
`;

export { Inline };
